import Page from 'components/Page';
import React, { useEffect, useMemo, useState } from 'react';
import TicketsList from './components/TicketsList';
import DateSelector from './components/DateSelector';
import './tickets.css';
import MyDatePicker from 'components/DatePicker';
import { API } from 'common';
import moment from 'moment';
import QueryString from 'utils/queryString';
import storage from 'utils/sessionStorage';
const FORMAT_DATE = 'YYYY-MM-DD';

export default function Tickets() {
  const [activeTab, setActiveTab] = useState('CLOSE');
  const [loading, setLoading] = useState('');
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    totalPage: 0
  });
  const [dateValue, setDateValue] = useState(() => {
    const tickets_filter = storage.tickets_filter.get();
    return tickets_filter ? tickets_filter : '';
  }); 

  const date = useMemo(() => dateValue ? moment(dateValue) : moment(), [dateValue]);

  const fetchData = async (_status) => {
    const params = {
      startTime: dateValue || moment().format('YYYY-MM-DD'),
      type: activeTab,
      page: pagination.page,
      limit: pagination.limit
    };
    const query = QueryString.stringify(params);
    setLoading(true);
    try {
      const res = await API.get(`/report/getBillV2?${query}`);
      if (res.data?.payload?.reportBill) {
        setData(res.data.payload.reportBill);
        setPagination(prev => ({
          ...prev,
          totalPage: res.data.payload.totalPage || 0
        }));
      }
    } catch (error) {
      console.error('Error fetching tickets:', error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, [activeTab, dateValue, pagination.page]);

  const handlePageChange = (newPage) => {
    setPagination(prev => ({
      ...prev,
      page: newPage
    }));
  };

  // Mock up
  const tickets = data.map(o => ({
    id: o.billNumber,
    billId: o.billId,
    customer: o.customerName || '--',
    date: `${o.strTime?.slice(0, 10)}`,
    time: o.strCheckoutTime,
    total: o.total,
    services: [],
  }));

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setPagination(prev => ({ ...prev, page: 1 })); // Reset to first page when changing tabs
  };

  return (
    <Page
      menu
      title='Closed Tickets'
    // Sticky={() => (
    //   // <TicketsHeader activeTab={activeTab} chooseTab={handleTabChange} />
    // )}
    >
      <div className='tickets'>
        <div className='tickets-content px-3 pt-3'>
          <MyDatePicker
            daily
            format={FORMAT_DATE}
            stringData={strData => {
              const params = QueryString.parse(strData);
              setDateValue(params?.startTime || '');
              storage.tickets_filter.set(params?.startTime || '');
              setPagination(prev => ({ ...prev, page: 1 })); // Reset to first page when changing date
            }}
            value={date}
            startFieldName='startTime'
            style={{ marginBottom: 0 }}
            customRender={({ date }) => (
              <DateSelector
                selectedDate={
                  date
                    ? `${date.format('ddd')}, ${date.format('MM-DD-YYYY')}`
                    : ''
                }
              />
            )}
          />
        </div>
        {loading ? <p style={{ textAlign: 'center', paddingBottom: 32, paddingTop: 32 }}>Loading...</p> :
          <TicketsList 
            tickets={tickets} 
            pagination={pagination}
            onPageChange={handlePageChange}
          />
        }
      </div>
    </Page>
  );
}
